import React, { useEffect, useRef, useState } from 'react'
import BrightcovePlayer from '@brightcove/react-player-loader'
import './Player.scss'
import PlaylistItem from '../PlaylistItem/PlaylistItem'
import { toHHMMSS } from '../PlaylistItem/PlaylistItem'
import breakpoints from '../../utils/breakpoints'

const Player = ({ currentVideo, playerId, playlist }) => {
  const messageHandler = (event) => {
    if (event.data === 'Share') {
      player.socialOverlay.show()
    }
  }

  const [height, setHeight] = useState('100%')
  const [loaded, setLoaded] = useState(false)
  const [player, setPlayer] = useState(null)
  const [playerVideo, setPlayerVideo] = useState(currentVideo);
  const autoPlayRef = React.useRef(false);
  const playlistRef = useRef(null);

  const shouldAutoplay = (e) => {
    console.log('autoplay', autoPlayRef.current, player.paused(), player.ended())
    if (autoPlayRef.current) {
      player.paused() || player.ended() ? player.play() : player.pause()
    }
  }
  useEffect(() => {
    if (!player) return
    window.addEventListener('message', messageHandler, false)
    window.addEventListener('resize', resizeHandler, false)

    player.el() && player
      .el()
      .firstChild.addEventListener('canplaythrough', shouldAutoplay, false)
    return () => {
      window.removeEventListener('message', messageHandler, false)
      window.removeEventListener('resize', resizeHandler, false)
      player.el() && player
        .el()
        .firstChild.removeEventListener('canplaythrough', shouldAutoplay, false)
    }
  }, [player])

  useEffect(() => {
    if (!player || !playerVideo.duration) return
    console.log('overlay set');
    player.overlay({
      overlays: [
        {
          content: `<a href="javascript:window.postMessage('Share');" class="mck-share2-icon" role="button" aria-label="Share Menu" data-label="Share" aria-expanded="false">&nbsp;Share</a>`,
          class: 'shareOverlay',
          align: 'top-right',
          start: 'loadstart',
        },
        {
          class: 'vjs-overlay-bottom',
          content:
            playerVideo.overlayText + '<br/>' + toHHMMSS(playerVideo.duration),
          start: 'loadstart',
          end: 'play',
          align: 'bottom',
        },
        {
          class: 'vjs-overlay-bottom',
          content:
            playerVideo.overlayText + '<br/>' + toHHMMSS(playerVideo.duration),
          start: 'loadedmetadata',
          end: 'play',
          align: 'bottom',
        },
      ],
    })
  }, [player, playerVideo])

  useEffect(() => {
    if (!player || !player.socialOverlay) return
    console.log('share link set');
    if (player.socialOverlay) {
      const options = typeof player.socialOverlay === 'undefined' ? {} : player.socialOverlay.options();
      const url = new URL(window.location.href);
      url.hash = playerVideo.id;
      player.socialOverlay.options({ ...options, title: playerVideo.shortTitle, url: url })
    }
  }, [player, playerVideo])

  const onSuccess = async (success) => {
    resizeHandler()
    if (!player) {
      setPlayer(success.ref)
    }
    setLoaded(true)
  }

  const resizeHandler = () => {
    if (window.innerWidth > breakpoints.mobile)
      setHeight(
        document.querySelector('.brightcove-react-player-loader').clientHeight - document.querySelector('.segment').clientHeight +
        'px',
      )
    else setHeight('100%')
  }

  const updateVideo = async (newVid, scroll, autoplay) => {
    autoPlayRef.current = autoplay;
    if (window.appEventData) {
      window.appEventData.push({
        event: 'UI Item Clicked',
        linkInfo: {
          regions: 'Episode video change',
          text: 'Switching video to ' + newVid.shortTitle,
        },
      })
    }
    setPlayerVideo(newVid)
    if (!player) return;
    if (scroll)
      player.el().scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });

    if (autoplay)
      shouldAutoplay(false);

  }

  useEffect(() => {
    updateVideo(currentVideo);
  }, [currentVideo])

  return (
    <div className="player-div d-flex">
      <div className="player">
        <BrightcovePlayer
          accountId="1971571337001"
          videoId={playerVideo.id}
          playerId={playerId}
          embedOptions={{ responsive: true }}
          onSuccess={onSuccess}
          playsinline
        ></BrightcovePlayer>
      </div>
      <div className="playlist">
        <div className="dds-u-height-auto segment" aria-label="listitem">
          {playlist.length} videos
        </div>

        <div role="list" ref={playlistRef} className="playlistItems" style={{ maxHeight: height }}>
          {loaded &&
            playlist.map((item, index) => (
              <React.Fragment key={item.id}>
                {index === 0 ? <hr aria-hidden="true" key="onlyonce" /> : ''}
                <PlaylistItem
                  key={`pl-item-${item.id}`}
                  item={item}
                  isSelected={item.id === playerVideo.id}
                  updateVideo={updateVideo}
                  playlistRef={playlistRef}
                />
                <hr className="m-0" aria-hidden="true" />
              </React.Fragment>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Player
